import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    listImage: {
        width: '95%',
        height: '100%',
        maxWidth: 90,
        resizeMode: 'stretch',
        alignSelf:'center'
    },
    listImageBorder:{
        borderRadius: 12,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#666666',
    },
    listFavorite: {
        position: 'absolute',
        bottom: 0,
        right: 0,
    },
    listStatus: {
        position: 'absolute',
        top: 4,
        left: 4,
        paddingHorizontal: 4,
        paddingVertical: 3,
        borderRadius: 4,
    },
    listContentRight: {
        paddingLeft: 10,
        paddingBottom: 5,
        flexDirection:"column",
        flex:3
    },
    listContentLeft: {
        paddingBottom: 5,
        flex:1
    },
    listContent: {
        flex:1,
        marginBottom:50,
        backgroundColor:'#ffffff',
        marginHorizontal:20,
        fontFamily: 'Raleway',
        fontSize: 11
    },
    listContentTitle: {
        fontFamily: 'Raleway',
        marginBottom: 4,
        fontSize: 14,
        fontWeight: '600'
    },
    listContentBody: {
        flex:1,
        fontFamily: 'Raleway',
        fontWeight:'400',
        color:'#999999'
    },
    readMore: {
        flex:1,
        fontFamily: 'Raleway',
        fontWeight:'400',
        color:'rgb(98, 0, 238)'
    },
    iconText: {
        fontFamily: 'Raleway',
        fontWeight:'400',
        fontSize:11
    },
    shopNow: {
        borderWidth:1,
        borderStyle:"solid",
        paddingHorizontal:15,
        paddingVertical:7,
        textAlign:"center",
        width:'100%',
        alignSelf:"flex-end",
        fontFamily:'Raleway'
    },
    iconFull: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
